import { putApi } from '../../utils/api'

export async function updateOldApiListTableConfig({ data, entity }) {
  return putApi({
    data,
    endpoint: `idwell-api/api/v3/table/tables/${entity.plural}/config/`,
  })
}
